import React, { useCallback, lazy } from 'react';
import styled from 'styled-components';

import { Field } from 'react-final-form';
import { Box as MuiBox, Chip as MuiChip } from '@mui/material';
import { Icon } from 'components/ui';

const FormNumberCounter = (
  { width = '140px',
    name,
    value = 1,
    minValue = 0,
    maxValue = 5,
    onChange
  }
) => {

  const handleChange = useCallback((isPrev, input) => {
    if (isPrev && minValue >= value) return
    if (!isPrev && maxValue <= value) return
    
    let newValue = isPrev ? Math.max(parseInt(value) - 1, minValue) : Math.min(parseInt(value) + 1, maxValue);
    if (onChange) {
      onChange(`${newValue}`)
      return
    }
    input.onChange(`${newValue}`)
  }, [value, onChange])

  return (
    <Field name={name}>
      {({ input }) => (
        <MuiBox display="flex" alignItems="center" width={width}>
          <MuiBox>
            <SMuiChip
              onClick={() => handleChange(true, input)}
              label={<Icon icon="angle-left" style={{ fontSize: 22 }} />}
              variant="outlined"
              disabled={minValue >= value}
            />
          </MuiBox>
          <MuiBox>
            <SInputBox>{value}</SInputBox>
          </MuiBox>
          <MuiBox>
            <SMuiChip
              onClick={() => handleChange(false, input)}
              label={<Icon icon="angle-right" style={{ fontSize: 22 }} />}
              variant="outlined"
              disabled={maxValue <= value}
            />
          </MuiBox>
        </MuiBox>
      )}
    </Field>
  );
};

const SMuiChip = styled(MuiChip)`
  && {
    border-radius: 5px;
    height: 40px;
    width: 45px;
  }
`;
const SInputBox = styled(MuiBox)`
  && {
    border: 1px solid ${({theme}) => theme.palette.colors.gray300};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 5px;
    margin: 0 5px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: ${({theme}) => theme.palette.colors.black100};
    background: transparent;
  }
`;

export default FormNumberCounter;